import { HStack, Steps, useBreakpointValue, Box, Text, VStack } from "@chakra-ui/react";
import { useThemeContext } from "../../Context/ThemeContext";
import { useTheme } from "next-themes";

export const Stepper = ({ currentStep }) => {
  const { themeConfig } = useThemeContext();
  const { resolvedTheme } = useTheme();
  const theme = themeConfig[resolvedTheme === 'dark' ? 'dark' : 'light'];

  const steps = [
    {
      title: "Signup",
    },
    {
      title: "Verify Email",
    },
    {
      title: "Complete KYC",
    },
    {
      title: "Dashboard",
    },
  ];

  // Responsive values for stepper
  const isMobile = useBreakpointValue({ base: true, md: false });
  const stepperSize = useBreakpointValue({ base: 'xs', sm: 'sm', md: 'md' });
  const titleFontSize = useBreakpointValue({ base: 'xxs', sm: 'xs', md: 'sm' });

  // Mobile-specific layout
  if (isMobile) {
    return (
      <Box 
        width="100%" 
        px={2} 
        py={3}
        bg={theme.bgCard}
        borderRadius="md"
        boxShadow="sm"
      >
        <VStack spacing={2} align="stretch">
          <HStack justifyContent="space-between" width="100%" px={1}>
            {steps.map((step, index) => (
              <Box key={index} textAlign="center" flex={1}>
                <Box
                  width="28px"
                  height="28px"
                  borderRadius="50%"
                  bg={index <= currentStep ? theme.brandPrimary : theme.bgTertiary}
                  color={index <= currentStep ? theme.buttonPrimaryText : theme.textTertiary}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  margin="0 auto"
                  fontSize="sm"
                  fontWeight="bold"
                  transition="all 0.3s ease"
                >
                  {index < currentStep ? "✓" : index + 1}
                </Box>
                <Text 
                  fontSize="xs" 
                  mt={1}
                  color={index === currentStep ? theme.brandPrimary : theme.textTertiary}
                  fontWeight={index === currentStep ? "semibold" : "normal"}
                  whiteSpace="normal"
                  maxWidth="100px"
                  mx="auto"
                  lineHeight="1.2"
                >
                  {step.title}
                </Text>
              </Box>
            ))}
          </HStack>
          <Box width="100%" bg={theme.bgTertiary} height="3px" borderRadius="full" mt={2}>
            <Box 
              bg={theme.brandPrimary} 
              height="100%" 
              width={`${(currentStep / (steps.length - 1)) * 100}%`}
              borderRadius="full"
              transition="width 0.5s ease-in-out"
            />
          </Box>
        </VStack>
      </Box>
    );
  }

  // Desktop/tablet layout
  return (
    <HStack margin={0} justifyContent='center' width="100%" px={{ base: 2, sm: 4 }}>
      <Steps.Root 
        defaultStep={currentStep} 
        count={steps.length} 
        size={stepperSize}
        width="100%"
        maxWidth={{ base: "100%", sm: "500px", md: "700px" }}
        mx="auto"
      >
        <Steps.List width="100%">
          {steps.map((step, index) => (
            <Steps.Item key={index} index={index} title={step.title}>
              <Steps.Indicator />
              <Steps.Title fontSize={titleFontSize}>{step.title}</Steps.Title>
              <Steps.Separator />
            </Steps.Item>
          ))}
        </Steps.List>

        {steps.map((step, index) => (
          <Steps.Content key={index} index={index}></Steps.Content>
        ))}
        <Steps.CompletedContent>Welcome to Dashboard</Steps.CompletedContent>
      </Steps.Root>
    </HStack>
  );
};